<template>
    <b-input v-model="model"
             v-mask="['##.###-###']"
             :modelEndereco="modelEndereco"
             :required="required"
             :disabled="disabled"
             :placeholder="placeholder"
             @blur="blurDefault"
             @input="inputDefault"></b-input>
</template>

<script>
    export default {
        props: {
            value: null,
            modelEndereco: { type: Object, default: null },
            input: { type: Function, default: null },
            blur: { type: Function, default: null },
            required: { default: false },
            disabled: { default: false },
            placeholder: { default: '' }
        },
        methods: {
            inputDefault: function (val) {
                //this.$set(val, this.model)
                if (this.input)
                    this.input(val)
            },
            blurDefault: function (val) {
                let th = this
                if (th.model && th.$api.UI.Format.SomenteNumeros(th.model).length == 8) {
                    th.$api.ViaCEP.buscarCep(th.$api.UI.Format.SomenteNumeros(th.model)).then(function (response) {
                        if (response.erro) {
                            th.$api.UI.ShowAlert('', 'Endereço não Localizado pelo CEP')
                        } else if (th.modelEndereco) {
                            th.modelEndereco.logradouro = response.logradouro
                            th.modelEndereco.bairro = response.bairro
                            th.modelEndereco.uf = response.uf
                            th.modelEndereco.cidade = response.localidade

                            th.$set(th.modelEndereco, th.modelEndereco)
                        }
                        if (th.blur)
                            th.blur(response)
                    })
                } else {
                    th.$api.UI.ShowAlert('', 'CEP no Formato Inválido')
                    if (th.blur)
                        th.blur()
                }
            }
        },
        computed: {
            model: {
                get() {
                    return this.$api.UI.Format.Cep(this.value)
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        }
    };
</script>